import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { queryCustomList } from '@api/crm/crm';
import ModalDepartment from './ModalDepartment';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
      visible: false,
      selectUuid: '',
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = (pageNo, condition) => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo,
    });
    queryCustomList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  handleChange = () => {};

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.loadData(1, values.condition);
      }
    });
  };

  handleFormReset = e => {
    e.preventDefault();
    this.props.form.resetFields();
    this.loadData(1);
  };

  handleModalVisible = visible => {
    this.setState({ visible, selectUuid: '' });
  };

  showModal = uuid => {
    this.setState({
      selectUuid: uuid,
      visible: true,
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        <Row gutter={{ md: 8, lg: 24, xl: 48 }} style={{ minWidth: '650px' }}>
          <Col md={8} sm={24} style={{ minWidth: '400px' }}>
            <FormItem label="搜索条件">
              {getFieldDecorator('condition')(
                <Input placeholder="请输入" style={{ minWidth: '200px' }} />,
              )}
            </FormItem>
          </Col>
          <Col md={8} sm={24}>
            <span className="submitButtons">
              <Button type="primary" htmlType="submit">
                查询
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
                重置
              </Button>
            </span>
          </Col>
        </Row>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '客户名称',
        dataIndex: 'name',
        render: (text, record) => {
          return <Link to={`/crm/custom/edit/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '客户行业',
        dataIndex: 'category',
      },
      {
        title: '来源渠道',
        dataIndex: 'origin',
      },
      {
        title: '更新时间',
        dataIndex: 'updateTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return <a onClick={() => this.showModal(record.uuid)}>下放</a>;
        },
      },
    ];
  };

  render() {
    const { data, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListForm">{this.renderSearchForm()}</div>
          <div className="tableListOperator">
            <Link to="/crm/custom/add">
              <Button type="primary">添加</Button>
            </Link>
            <Link to="/crm/custom/protect">
              <Button>客户保护</Button>
            </Link>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {this.state.visible ? (
          <ModalDepartment
            handleModalVisible={this.handleModalVisible}
            uuid={this.state.selectUuid}
          />
        ) : (
          ''
        )}
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/custom/Index.js